import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=02fa7fcd&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=02fa7fcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fa7fcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02fa7fcd')) {
      api.createRecord('02fa7fcd', component.options)
    } else {
      api.reload('02fa7fcd', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=02fa7fcd&scoped=true&", function () {
      api.rerender('02fa7fcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lEcC2vEBvGyG/JS/comp/GuestBox.vue"
export default component.exports